/* src/views/logements/proto/FicheChrome.jsx — LE CHROME DE LA FICHE logement
   (bandeau + bascule à dix sous-onglets), transcrit de
   docs/handoff/logements-1-fiche.jsx (livré 2026-08-27).

   AJOUT DÉCIDÉ (Dimitri, lot 4 point 6) : la pastille « Enregistrer » vit
   dans le bandeau — le prototype n'en avait pas, mais la moitié des champs
   de la fiche écrivent un brouillon local (fbz8-cfg) qui serait perdu en
   silence sans elle. Elle s'allume terra quand une modif attend. */

import React from 'react'

export function BandeauFiche({ sousTitre, titre, dirty, savedAt, onSave, onRetour }) {
  return (
    <div className="bandeau">
      {/* zIndex 1 : le cercle décoratif du bandeau (.bandeau::after, CSS du
          proto) recouvre sinon les boutons en haut à droite — clic mort. */}
      <div style={{ position: 'relative', zIndex: 1, display: 'flex',
        alignItems: 'flex-start', gap: '12px' }}>
        <div style={{ flex: '1', minWidth: '0' }}>
          <p className="bSous">{sousTitre}</p>
          <h2 className="bTitre">{titre}</h2>
        </div>
        {/* Pastille Enregistrer (décision 6) — terra si brouillon en attente,
            « ✓ Sauvegardé » 4 s après un save, sinon discrète. */}
        <button onClick={onSave} data-testid="fiche-enregistrer"
          disabled={!dirty}
          title={dirty ? 'Des modifications attendent d’être enregistrées'
            : (savedAt ? 'Sauvegardé' : 'Rien à enregistrer')}
          style={{ flexShrink: '0', display: 'inline-flex', alignItems: 'center',
            gap: '6px', minHeight: '36px', padding: '0 12px', borderRadius: '10px',
            background: dirty ? 'var(--terra)' : 'rgba(255,255,255,.16)',
            border: dirty ? '1px solid var(--terra)' : '1px solid rgba(255,255,255,.24)',
            color: '#fff', fontSize: '11.5px', fontWeight: dirty ? '600' : '400',
            cursor: dirty ? 'pointer' : 'default',
            opacity: dirty || savedAt ? 1 : 0.65 }}>
          {dirty ? '● Enregistrer' : (savedAt ? '✓ Sauvegardé' : 'Enregistrer')}
        </button>
        <button onClick={onRetour} data-testid="fiche-retour-parc"
          style={{ flexShrink: '0', display: 'inline-flex', alignItems: 'center',
            gap: '6px', minHeight: '36px', padding: '0 12px', borderRadius: '10px',
            background: 'rgba(255,255,255,.16)', border: '1px solid rgba(255,255,255,.24)',
            color: '#fff', fontSize: '11.5px', cursor: 'pointer' }}>
          <span style={{ fontSize: '13px' }}>‹</span>Le parc</button>
      </div>
    </div>
  )
}

/* ── la bascule à dix sous-onglets ─────────────────────────────────── */
export const FICHE_ONGLETS = [
  { id: 'info', lb: 'Infos' },
  { id: 'instr', lb: 'Instructions' },
  { id: 'livret', lb: 'Livret' },
  { id: 'check', lb: 'Checklist' },
  { id: 'linge', lb: 'Linge' },
  { id: 'docs', lb: 'Documents' },
  { id: 'site', lb: 'Site' },
  { id: 'services', lb: 'Services' },
  { id: 'avis', lb: 'Avis' },
  { id: 'savoir', lb: 'Ce que l’IA sait' },
]

export function BasculeFiche({ actif, onSous, visibles }) {
  const liste = visibles
    ? FICHE_ONGLETS.filter((o) => visibles.includes(o.id))
    : FICHE_ONGLETS
  // Collante sous la barre de menu (décision Dimitri 2026-08-28 : une fiche à
  // dix onglets garde sa bascule visible). top ≈ hauteur de BarreUnique
  // (63 px ordinateur, 53 px téléphone) — l'écran tranche le pixel près.
  return (
    <div className="bascule" style={{ position: 'sticky',
      top: 'var(--fbz-barre-h, 63px)', zIndex: 20 }}>
      {liste.map((o) => (
        <button key={o.id} className={actif === o.id ? 'on' : ''}
          data-testid={`fiche-sous-${o.id}`}
          onClick={() => onSous(o.id)}>{o.lb}</button>
      ))}
    </div>
  )
}
